import {FC, useEffect} from "react"

import {useCustomerInfo} from "./useCustomerInfo"

import {useAnalytics} from "@indebted/analytics"

const CustomerInfoTracker: FC = () => {
	const {setUserId, setUserProperties} = useAnalytics()
	const {customerInfo} = useCustomerInfo()

	useEffect(() => {
		if (
			customerInfo &&
			customerInfo.ClientID &&
			customerInfo.CustomerID &&
			customerInfo.OutstandingBalance &&
			customerInfo.OutstandingBalanceCurrency
		) {
			setUserId(customerInfo.CustomerID)
			setUserProperties({
				ClientID: customerInfo.ClientID,
				OutstandingBalance: customerInfo.OutstandingBalance,
				OutstandingBalanceCurrency: customerInfo.OutstandingBalanceCurrency,
				CustomerRef: customerInfo.CustomerRef,
			})
		}
	}, [customerInfo, setUserId, setUserProperties])

	return null // This component does not render anything
}

export {CustomerInfoTracker}
